const initAcc = () => {
    const t = document.querySelector('.js-accessibility-trigger');
    if (!t) return;
    t.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.acsb-trigger')?.click();
    }, { once:false });
    };

// run after DOM is ready
(document.readyState === 'loading')
? document.addEventListener('DOMContentLoaded', initAcc, { once:true })
: initAcc();

// Shopify themes may AJAX-reload sections; re-bind when they do
document.addEventListener('shopify:section:load', initAcc);